import { render, staticRenderFns } from "./Flume.vue?vue&type=template&id=e5015588&scoped=true&"
import script from "./Flume.vue?vue&type=script&lang=js&"
export * from "./Flume.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5015588",
  null
  
)

export default component.exports